import { Upload5 } from 'blaze-ui/icons'
import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { useCurrentImageLibrary } from 'hooks/useCurrentImageLibrary'
import { ACCEPTED_AUDIO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import { Button } from 'blaze-ui/Button'
import { AlmanacFile } from 'types'

interface AudioUploadTileProps {
  brandKitId: number
  onSuccess: (newAudio: AlmanacFile) => void
}

export const AudioUploadTile = ({ brandKitId, onSuccess }: AudioUploadTileProps) => {
  const imageLibrary = useCurrentImageLibrary()

  const { uploadImageFiles, isUploading } = useImportMediaFiles(false, (uploadedFiles) => {
    onSuccess(uploadedFiles[0])
  })

  return (
    <FileTrigger
      onSelect={(fileList) => {
        if (!fileList || !imageLibrary?.key) return

        return uploadImageFiles(Array.from(fileList), imageLibrary.key, { brand_kit_id: brandKitId })
      }}
      accept={ACCEPTED_AUDIO_MIME_TYPES}
      allowsMultiple={false}
      aria-label="Upload Audio"
    >
      <Button
        variant="secondary"
        size="lg"
        useChildClass
        color="var(--selected-fill)"
        isDisabled={isUploading}
        frontIcon={Upload5}
      >
        Upload Audio
      </Button>
    </FileTrigger>
  )
}
